import gql from 'graphql-tag';
import { Component, Vue } from 'vue-property-decorator';
import SuggestionsListCollaborativeFilteringAdderComponent from '../components/bookshop/suggestionsListCollaborativeFilteringAdder.vue';
import SuggestionsListHighDemandAdderComponent from '../components/bookshop/suggestionsListHighDemandAdder.vue';
import SuggestionsListAwardsAdderComponent from '../components/bookshop/suggestionsListAwardsAdder.vue';
import SuggestionsListKeywordsAdderComponent from '../components/bookshop/suggestionsListKeywordsAdder.vue';
import SuggestionsListOpenSearchAdderComponent from '../components/bookshop/suggestionsListOpenSearchAdder.vue';
import SuggestionsListPopularAdderComponent from '../components/bookshop/suggestionsListPopularAdder.vue';
import SuggestionsListStaffPicksAdderComponent from '../components/bookshop/suggestionsListStaffPicksAdder.vue';

@Component({
  components: {
    SuggestionsListKeywordsAdderComponent,
    SuggestionsListOpenSearchAdderComponent,
    SuggestionsListPopularAdderComponent,
    SuggestionsListAwardsAdderComponent,
    SuggestionsListHighDemandAdderComponent,
    SuggestionsListStaffPicksAdderComponent,
    SuggestionsListCollaborativeFilteringAdderComponent,
  },
})
export default class SuggestionsListAdder extends Vue {
  public readonly suggestionsListQuery = gql`
    query suggestionsList($suggestionsListId: ID!) {
      suggestionsList(suggestionsListId: $suggestionsListId) {
        library {
          id
        }
        id
        project {
          id
          requirements {
            keywords
          }
        }
      }
    }
  `;

  public get variables() {
    return { suggestionsListId: this.$route.params.suggestionsListId };
  }
}
